<div [ngStyle]="{ height: _height || defaultHeight }">
  <app-widgets-toolbar
    class="pb-16"
    *ngIf="_showToolbar"
    [colour]="toolbarColour || '#0277bd'"
    [widgets]="widgets"
    [layout]="_layout"
    (lockToggled)="toggleLock($event)"
    (addWidget)="addWidget($event)"
    (removeAllWidgets)="removeAllWidgets($event)"
  >
  </app-widgets-toolbar>

  <div class="gridster-container" [ngClass]="{ 'with-shadow mt-12': border }">
    <gridster [options]="_options" class="mat-drawer-container" style="background-color: white">
      <gridster-item
        [item]="item.config"
        *ngFor="let item of _layout"
        [class.selected-field]="selectedField === item"
        class="no-transition transparent-bg gridster-item"
        (mouseover)="onWidgetMouseOver(item)"
        (mouseout)="onWidgetMouseOut(item)"
        [ngStyle]="{
          'border-color':
            !_locked &&
            item?.hovered &&
            hoveredWidgetId &&
            hoveredWidgetId == item?.id &&
            hoveredWidgetType &&
            hoveredWidgetType == item?.type
              ? '#dddddd'
              : 'transparent'
        }"
      >
        <div
          *ngIf="
            !_locked &&
            (isTouchScreen ||
              (item?.hovered &&
                hoveredWidgetId &&
                hoveredWidgetId == item?.id &&
                hoveredWidgetType &&
                hoveredWidgetType == item?.type))
          "
          class="widget-options"
        >
          <button
            id="dragbtn"
            mat-mini-fab
            class="drag-handler widget-options-btn"
            matTooltip="{{ 'Customise ' + (item.title || item.name) }}"
            aria-label="{{ 'Customise ' + (item.title || item.name) }}"
          >
            <mat-icon>open_with</mat-icon>
          </button>
          <button
            id="removebtn"
            mat-mini-fab
            (mousedown)="removeWidget($event, item)"
            (touchstart)="removeWidget($event, item)"
            class="widget-options-btn"
            matTooltip="{{ 'Delete ' + (item.title || item.name) }}"
            aria-label="{{ 'Delete ' + (item.title || item.name) }}"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            *ngIf="item?.configurable"
            id="settingsbtn"
            mat-mini-fab
            (click)="displayWidgetSettings($event, item)"
            class="widget-options-btn"
            style="margin-right: 0px"
            matTooltip="{{ 'Edit ' + (item.title || item.name) + ' Settings' }}"
            aria-label="{{ 'Edit' + (item.title || item.name) + ' Settings' }}"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </div>

        <div
          class="gridster-item-content no-padding"
          [class.mat-card]="!contentBackgroundColor"
          style="height: 100%; padding: 1px"
          [style.background-color]="contentBackgroundColor || 'white'"
        >
          <ndc-dynamic
            [ndcDynamicComponent]="item.widget"
            [ndcDynamicInputs]="item.metadata"
            [ndcDynamicOutputs]="handleMetaChanges"
          >
          </ndc-dynamic>
        </div>
      </gridster-item>
    </gridster>
  </div>
</div>
